import { connectLiveMessages } from 'components/secondaryMarket/live/sidePanel/messages.connect';
import { ConnectedQuotedExpiredSidePanel } from 'components/secondaryMarket/live/sidePanel/quoted/QuotedExpiredSidePanel.connect';
import { ConnectedQuotedSidePanel } from 'components/secondaryMarket/live/sidePanel/quoted/QuotedSidePanel.connect';
import { ConnectedTradedSidePanel } from 'components/secondaryMarket/live/sidePanel/traded/TradedSidePanel.connect';
import { ErrorSidePanel } from 'components/secondaryMarket/shared/SidePanel/ErrorSidePanel';
import { SidePanelStructure } from 'components/secondaryMarket/shared/SidePanel/SidePanelStructure';
import { StreamingBeforeQuotedSidePanel } from 'components/secondaryMarket/shared/SidePanel/StreamingBeforeQuotedSidePanel';
import type { IntlKey } from 'locales';
import type { LiveForm } from 'state/secondaryMarket/live/form/input/inputForm.model';
import type { LiveStatus } from 'state/secondaryMarket/live/live.model';

import { ProcessingSidePanel } from '../../shared/SidePanel/TradingSidePanel';
import { QuotingSidePanel } from './quoting/QuotingSidePanel';
import type { LiveSidePanelProps } from './sidePanel.connect';

const ConnectedStreamingBeforeQuotedSidePanel = connectLiveMessages(StreamingBeforeQuotedSidePanel<LiveForm>);

const getErrorPanelFooterMessageKey = (status: LiveStatus): IntlKey | undefined => {
  switch (status) {
    case 'QUOTE_REJECTED':
      return 'secondaryMarket.sidePanel.label.quoteRejected';
    case 'TRADE_REJECTED':
      return 'secondaryMarket.sidePanel.label.tradeRejected';
  }
};

function LiveSidePanelContent({ status, tabId, ...props }: LiveSidePanelProps) {
  switch (status) {
    case 'NOT_READY':
    case 'READY':
      return <ConnectedStreamingBeforeQuotedSidePanel tabId={tabId} status={status} {...props} />;
    case 'QUOTING':
      return <QuotingSidePanel tabId={tabId} />;
    case 'TRADING':
      return <ProcessingSidePanel />;
    case 'QUOTED':
    case 'QUOTED_ENDED':
      return <ConnectedQuotedSidePanel formId={tabId} />;

    case 'QUOTED_EXPIRED':
      return <ConnectedQuotedExpiredSidePanel formId={tabId} />;
    case 'QUOTE_REJECTED':
    case 'TRADE_REJECTED':
    case 'QUOTE_FAILED':
    case 'TRADE_FAILED':
      const errorPanelFooterMessageKey = getErrorPanelFooterMessageKey(status);
      return (
        <ErrorSidePanel
          tabId={tabId}
          orderActionType={'LIVE'}
          onDone={props.onDone}
          errorMessage={props.errorMessage}
          timeout={props.timeout}
          panelFooterMessageKey={errorPanelFooterMessageKey}
          onQuote={props.onQuote}
        />
      );
    case 'TRADE_DONE':
      return <ConnectedTradedSidePanel formId={tabId} />;
  }
}
export function LiveSidePanel(props: LiveSidePanelProps) {
  return (
    <SidePanelStructure>
      <LiveSidePanelContent {...props} />
    </SidePanelStructure>
  );
}
